// extracted by mini-css-extract-plugin
export var askAiIcon = "_mr-9";
export var container = "_mr-0";
export var groupSeparator = "_mr-a";
export var highlight = "_mr-4";
export var resultIcon = "_mr-5";
export var resultItem = "_mr-7";
export var resultSubtitle = "_mr-3";
export var resultTitle = "_mr-2";
export var resultsList = "_mr-1";
export var searchGroup = "_mr-6";
export var selected = "_mr-8";